import * as React from "react";
const SvgDownCaret = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 8, viewBox: "0 0 11 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L5.5 7L10 1", stroke: "currentColor" }));
export default SvgDownCaret;
